const articleContent = [
  {
    id: 1,
    translationKey: 'SSL_CERTIFICATE',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Michael' },
    category: {
      slug: 'configuration',
      icon: '📦',
    },
    views: 3400,
  },
  {
    id: 2,
    translationKey: 'FIRST_PORTAL',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'John' },
    category: {
      slug: 'onboarding',
      icon: '🧑‍🍳',
    },
    views: 400,
  },
  {
    id: 3,
    translationKey: 'ORGANIZING_CONTENT',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Fernando' },
    category: {
      slug: 'best-practices',
      icon: '⛺️',
    },
    views: 400,
  },
  {
    id: 4,
    translationKey: 'CUSTOMIZING_APPEARANCE',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Jane' },
    category: {
      slug: 'design',
      icon: '🎨',
    },
    views: 400,
  },
  {
    id: 5,
    translationKey: 'THIRD_PARTY_TOOLS',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Sarah' },
    category: {
      slug: 'integrations',
      icon: '🔗',
    },
    views: 2800,
  },
  {
    id: 6,
    translationKey: 'USER_PERMISSIONS',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Alex' },
    category: {
      slug: 'administration',
      icon: '🔐',
    },
    views: 1200,
  },
  {
    id: 7,
    translationKey: 'FAQ_SECTIONS',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Emily' },
    category: {
      slug: 'content-management',
      icon: '📝',
    },
    views: 5600,
  },
  {
    id: 8,
    translationKey: 'SEARCH',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'David' },
    category: {
      slug: 'features',
      icon: '🔍',
    },
    views: 1800,
  },
  {
    id: 9,
    translationKey: 'METRICS',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Rachel' },
    category: {
      slug: 'analytics',
      icon: '📊',
    },
    views: 3200,
  },
  {
    id: 10,
    translationKey: 'MULTILINGUAL',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Carlos' },
    category: {
      slug: 'localization',
      icon: '🌍',
    },
    views: 900,
  },
  {
    id: 11,
    translationKey: 'TUTORIALS',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Olivia' },
    category: {
      slug: 'education',
      icon: '🎓',
    },
    views: 4100,
  },
  {
    id: 12,
    translationKey: 'FEEDBACK',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Nathan' },
    category: {
      slug: 'user-engagement',
      icon: '💬',
    },
    views: 750,
  },
  {
    id: 13,
    translationKey: 'SEO',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Sophia' },
    category: {
      slug: 'seo',
      icon: '🚀',
    },
    views: 2900,
  },
  {
    id: 14,
    translationKey: 'INTERNAL_KNOWLEDGE',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Daniel' },
    category: {
      slug: 'internal-resources',
      icon: '🏢',
    },
    views: 1500,
  },
];

export const localizeArticleContent = translations =>
  articleContent.map(article => {
    const copy = translations[article.translationKey];

    return {
      ...article,
      title: copy.TITLE,
      category: {
        ...article.category,
        name: copy.CATEGORY,
      },
    };
  });
